import { type FunctionComponent, } from "react";
import "./BracketLogo.scss";

export declare type BracketLogoProps = {
	className?: string;
	mode?: "dark" | "light";
}

export const BracketLogo: FunctionComponent<BracketLogoProps> = ({
	className = "",
	mode = "dark",
}) => {

	const classes = () => [ "bracket-logo-01-svg", mode, ].concat(className.split(" ")).join(" ");

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 780 90" className={classes()}>
			<path d="M138.98,61.75c0,8.16-7.01,14.75-15.7,14.75h-61.95V18.74h61.95c8.69,0,15.38,6.59,15.38,14.76v2.51c0,4.71-2.2,8.89-5.76,11.61,3.66,2.62,6.07,6.91,6.07,11.62v2.51h.01ZM128.93,42.6v-13.81h-57.55v13.81h57.55ZM128.93,66.46v-13.81h-57.55v13.81h57.55Z" />
			<path d="M231.98,76.51h-10.05v-17.58h-56.09v17.58h-10.05V18.75h60.48c8.69,0,15.7,7.01,15.7,15.7v8.79c0,4.81-2.51,8.58-6.38,10.67,3.87,2.09,6.38,5.86,6.38,10.67v11.93h0ZM221.94,48.88v-20.09h-56.09v20.09h56.09Z" />
			<path d="M309.06,23.91l36.76,52.67h-12.66l-9.63-13.6h-52.53l-9.52,13.6h-12.66l37.23-52.67,3.45-5.23h15.8l3.77,5.23h-.01ZM316.3,52.93l-19.05-27.31-19.05,27.31h38.1Z" />
			<path d="M438.82,76.51h-60.48c-8.69,0-15.7-7.01-15.7-15.7v-26.37c0-8.69,7.01-15.7,15.7-15.7h60.48v10.05h-66.14v37.67h66.14v10.04h0Z" />
			<path d="M465.69,76.51h-10.05V18.75h10.05v57.76ZM474.27,37.37l2.92-1.49,33.6-17.14h21.98l-56.51,28.67,57.24,29.09h-21.87l-37.36-19.05M463.95,42.69l13.24-6.81v22.99l-18.38-8.82,5.15-7.35h-.01Z" />
			<path d="M626.5,76.51h-60.49c-4.89,0-15.63-.11-15.63-.11,0,0-.07-11.8-.07-15.59v-26.37c0-4.88.07-15.7.07-15.7h76.11v10.05h-66.14v13.81h66.14v10.05h-66.14v13.81h66.14v10.04h.01Z" />
			<path d="M718.67,28.79h-32.65v47.72h-10.05V28.79h-32.65v-10.05h75.34v10.05h.01Z" />
			<path d="M28.3,90H0V1.38h28.3v13.29h-13.23v62.03h13.23v13.29h0Z" />
			<path d="M751.7,75.32h13.23V13.29h-13.23V0h28.3v88.62h-28.3v-13.29h0Z" />
		</svg>
	)

}
